// extracted by mini-css-extract-plugin
module.exports = {"departments":"vm","departmentHeading":"wm","departmentSection":"xm","departmentName":"ym","departmentLink":"zm","expandIcon":"Am"};